import { render, staticRenderFns } from "./accountbatch.vue?vue&type=template&id=8f4f292c"
import script from "./accountbatch.vue?vue&type=script&lang=js"
export * from "./accountbatch.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports